export enum CLIENT_ROUTES {
  GET_ALL = "/clients",
  GET = "/clients/",
  CREATE = "/clients",
  UPDATE = "/clients/",
  REMOVE = "/clients/",
}
